import React, {useState, useEffect, useRef} from 'react';
import {useNavigate} from "react-router-dom";
import { connect } from 'react-redux';
import Head from '../../components/head/Head'
import Foot from '../../components/foot/Foot'
import {  Input,message,Modal,Progress,Statistic ,Select  } from 'antd';
import { transfer,transferBnb,balanceOf,signer } from '../../utils/ethers'
import copy from 'copy-to-clipboard'
import {shareLink} from '../../utils/const'
import NumberFormat from 'react-number-format'
import contractAddress from "../../utils/contractAddress.json"
import Moment from 'react-moment'
import CountUp from "react-countup";

import { useTranslation } from 'react-i18next'
import {getIdoInfo, addIdoBnb,addIdoJie} from "../../api";
import { CSSTransition } from 'react-transition-group';
import {
    WarningOutlined,CloseOutlined
  } from '@ant-design/icons';
  import './index.less';

import { max } from 'moment';

const nowTime = Date.parse(new Date()) / 1000
const mapStateToProps=(state)=>{
    return{
        isLogin:state.isLogin,
        address:state.address,
        pAddress:state.pAddress,
        chain:state.chain,
        flash:state.flash,
    }
}
const { Countdown } = Statistic;
const Rank = (props) => {
    const navigate = useNavigate()
    const audioRef = useRef(null);
    const { t } = useTranslation()
    const [num,setNum] = useState(0)
    const [list,setList] = useState([])
    const [list1,setList1] = useState([])
    const [mintPrice,setMintPrice] = useState(0)
    const [mintBnb,setMintBnb] = useState(0)
    const [levelJie,setLevelJie] = useState(0)
    const [receiveAddress,setReceiveAddress] = useState("")
    const [receiveJieAddress,setReceiveJieAddress] = useState("")
 const [isLock,setIsLock]=useState(false)
const [balanceUsdt,setBalanceUsdt]=useState(null)
 const [needUsdt,setNeedUsdt] = useState(10000)

    const [mints,setMints] = useState("")
 
    const [pm,setPm] = useState(0)
    const [bnb,setBnb] = useState(0.1)

    const [minted,setMinted] = useState(0)
    const [maxMint,setMaxMint] = useState(0)
 const [tab,setTab] = useState(1)
    const [per,setPer] = useState(0)
    const [isOpen,setIsOpen] = useState(true)
    const [showMint,setShowMint] = useState(true)
    const ref = useRef()

    const [nodeIndex , setNodeIndex] = useState(2)


    const _showMint = (e) =>{
        setShowMint(e)
    }

    const _getTuanInfo = () =>{
        if(props.address.length>0 && props.isLogin){
            getIdoInfo().then(res=>{
                if(res.code == 0){
                //     setReceiveAddress(res.data.receive)
                //     setReceiveJieAddress(res.data.receive1)
                //     setLevelJie(res.data.levelJie)
                //    setMintPrice(res.data.price)
                //     setMintBnb(res.data.eth)
                //     setMaxMint(res.data.total)
                //     setMinted(res.data.minted)
                //     setPer(res.data.per)
                setBalanceUsdt(res.data.usdt)
                  setList(res.data.list || [])
                  setList1(res.data.list1 || [])
                  
                    
                }else{
                    message.error(res.msg)
                }
               console.log(res)
            })
        }
    }

    const handleChange = (value) => {
        if(mintPrice == 0){
            return
        }
       
      
         if(value>9999){
            value = 9999
         }
          setMints(value);
           value= parseInt(value *100)/100
          setPm(parseInt(value/mintPrice*100)/100);
          setBnb(value);
        
    }

    const _max = () => {
        if(mintPrice == 0){
            return
        }

         if(parseFloat(balanceUsdt) <9.9){
            return
        }
       let _value = balanceUsdt
      
         if(_value>9999){
            _value = 9999
         }
          setMints(_value);
           _value= parseInt(_value *100)/100
          setPm(parseInt(_value/mintPrice*100)/100);
          setBnb(_value);
        
    }

    const addNode = () => {
        if(needUsdt == 1000){
            setNeedUsdt(3000)
        }else if(needUsdt == 3000){
            setNeedUsdt(5000)
        }else if(needUsdt == 5000){
            setNeedUsdt(1000)
        }
    }

    const subNode = () => {
        if(needUsdt == 1000){
            setNeedUsdt(5000)
        }else if(needUsdt == 3000){
            setNeedUsdt(1000)
        }else if(needUsdt == 5000){
            setNeedUsdt(3000)
        }
    }

    const add = () => {
        let value = 1
        if(mints.length==0){
             value = 1
        }else{
             value = parseInt(mints) +1
        }
        
        const regex = /^[0-9]*$/;
        
        if (regex.test(value) || value === '') {
         if(value>1000){
            value = 1000
         }
         setMints(value);
          setPm(parseInt(value*50000*100)/100);
          setBnb(parseInt(value*0.01*100)/100);
        }
    }

    const sub = () => {
        let value = 1
        if(mints.length==0){
            value = 1
        }else{
            value = mints -1
        }
        
        if (value <1){
            value =1
        }
        const regex = /^[0-9]*$/;
        
        if (regex.test(value) || value === '') {
         if(value>1000){
            value = 1000
         }
         setMints(value);
         setPm(parseInt(value*50000*100)/100);
          setBnb(parseInt(value*0.01*100)/100);
        }
    }

    

   


    const _balanceOf = () =>{
        
        if(props.address.length<=0 || !props.isLogin) return false
      
        balanceOf(props.address,'usdt').then(res=>{
            
            setBalanceUsdt(res)
        })

    }


    const _rand= () =>{
        // let address1 = (props.address).toLowerCase()
        // console.log(address1)
        // if(address1!= "0xecE259eeF7c8A1449a415A8b83Bf9622A41300e9"){
        //     message.error(t('g.暂未开始'))
        //     return
        // }
        // console.log(1111)
        // if(props.address.length<=0) return false
        // message.error(t('in.暂未开放'))
        // return false
          
          
        // let nowTime = Date.parse(new Date()) / 1000
        // if( nowTime < 1734175800){
        //     message.error(t('in.暂未开放'))
        //     return false
        // }
        if(props.address.length<=0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        // if(receiveJieAddress.length==0){
        //       message.error(t('mint.钱包地址获取错误'))
        //     return false
        // }



   

        if (parseInt(needUsdt)!=1000  && parseInt(needUsdt)!=3000 && parseInt(needUsdt)!=10000){
            return false
        }
      

        if(parseFloat(needUsdt)>parseFloat(balanceUsdt)){
           
            message.error(t('mint.您的USDT不足'))
            return false
        }

        if(isLock){
            return false
        }
        setIsLock(true)

         signer(props.address).then(res1=>{
                        addIdoJie({
                        address:props.address,
                        value:needUsdt.toString(),
                        pass:res1.pass,
                        hex:"0x",
                    }).then(
                        res=>{
                            message.success(res.msg)
                            
                            setNum(num+1);
                            setIsLock(false)
                        }, error=>{
                            setIsLock(false)
                            message.error(error)
                        })
                    },error=>{
                        setIsLock(false)
                         message.error(error)
                    })

        

                





    }

 

    const _isStartIdo = () =>{
    //  message.error(t('g.暂未开始'))
    //         return

    // if(props.address.toLowerCase()== "0xffc7fe90b6eb9ba1f0c1f6252bbd4285874c7660"){
            
    //     }else{
             
    //     }

//    let now = Date.now() /1000
//                 if(parseFloat(now) < 1766834880){
//                     message.error(t('g.暂未开始'))
//                         return
//                 }
    
        
        if(props.address.length === 0){
            message.error(t('head.请先连接钱包'))
            return false
        }
        if(props.isLogin === false){
            // message.error(t('mint.请先绑定推荐地址!'))
            props.setFlash(true)
            return false
        }
        if(receiveAddress.length==0){
              message.error(t('mint.钱包地址获取错误'))
            return false
        }
        if(bnb.length==0){
             message.error(t('mint.请重新输入铸造数量'))
             return false
        }
        if(parseFloat(bnb)<9.9 || parseFloat(bnb)>9999){
            message.error(t('mint.铸造价值9.9-9999U'))
            return false
       }
       if(isLock){
            return false
        }
        setIsLock(true)
      console.log(bnb)
      transfer(props.address,receiveAddress,"usdt",bnb).then(
    
            res2=>{
                // message.success(res2)
               addIdoBnb({
                    address:props.address,
                    mints:mints.toString(),
                    hex:res2.hash,
                    
                }).then(
                    res=>{
                        // audioRef.current.play()
                        // setIsOpen(false)
                        message.success(res.msg)
                     
                        setNum(num+1);
                        setIsLock(false)
                    })
                       
                    
            },err2=>{
                setIsLock(false)
                message.error(err2)
            }
        )
    }

    const changeNode = (e) =>{
        console.log(e)
        setNodeIndex(e)
        if(e==0){
            setNeedUsdt(1000)
        }else if(e==1){
            setNeedUsdt(3000)
        }else if(e==2){
            setNeedUsdt(5000)
        }
    }
  
const goUrl = (url)=>{
       
        if(props.address.length<=0 ){
            message.error(t('head.请先连接钱包'))
            return false
        }
        navigate(url,{
            state:{
                address:props.address
            }
        })
    }


const handleChange1 = (value) => {
  console.log(`selected ${value}`);
  setNeedUsdt(value)
};

    useEffect(() => {
        console.log(nowTime)
        props.setIsTiao(true)
        window.scrollTo(0, 0)
            // if(props.address.length>0 && !props.isLogin){
            //     setShowJoin(true)
            // }
            // _allIdoETH()
            // _getIdoList()



            // _balanceOf()
             //_getTuanInfo()
            // const timer = setInterval(() =>{_getTuanInfo()},20000)
            // ref.current = timer
            // return ()=>{
            //     clearInterval(ref.current)
            // }
    }, 
    // eslint-disable-next-line
    [props.isLogin,num]);

    const clearTimer = () =>{
        clearInterval(ref.current)
    }

    return (
        <>
            <Head/>
     
           
                      {/* <div className=' bg-[#F1F5F9] w-full lg:w-1/3   pt-20 text-white flex flex-col z-10'></div>    */}
            
            <div style={{"backgroundColor":"#000628"}} className='  w-full lg:w-1/3   pt-20 text-white flex flex-col z-10 indexBg33'>
                <div onClick={()=>window.history.back()} className='w-full h-16 px-4 flex flex-row justify-start items-center'>
                    <div className='mt-4 w-full h-12  flex flex-row justify-start items-center'>
                    <img alt='rr' className=' mr-1' src={require('../../assets/img/re.png')} style={{"width":"20px"}}></img>
                    <span className='text-2xl oblod text-gray-100'>{t('rank.榜单排行')}</span>
                    </div>
                
                </div>
                {/*  */}
                
                
                {/*  */}
                
                       
               
                
                {/*  */}
               

                        <>
                        {/* <div className='mt-10 w-full flex flex-row px-4'>
                            <span className='px-2 pb-2  text-gray-100 text-lg'>{t('mint.购买记录')}</span>
                        </div> */}
                        <div className=' bg-[#000F3A] mt-5 mx-4  pt-6 pb-6 rounded-xl flex flex-col items-start border border-[#0161F6]'>
                        {
                            list1.length>0?
                            list1.map((item,index)=>{
                                return(
                                    <>
                                    <div className='px-4 mt-3 mb-3 w-full flex flex-col items-center fontM'>
                                        <div className=' w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-xs flex flex-col'>
                                                <span className=' text-sm'>{t('mint.记录时间')}</span>
                                                <span className='text-sm mt-1 text-gray-100'>{item.add_time}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.状态')}</span>
                                                <span className='text-base text-green-500 block '>{t('mint.已确认')}</span>
                                            </div>
                                        </div>
                                        <div className='mt-4 w-full flex flex-row justify-between items-center'>
                                            <div className=' text-gray-400 text-sm flex flex-col '>
                                                <span>{t('mint.节点类型')}</span>
                                                <span className='text-base mt-1 text-gray-100'>{item.usdt==10000?t('mint.创世节点'):item.usdt==3000?t('mint.五行社区'):t('mint.首富节点')}</span>
                                            </div>
                                            <div className=' text-gray-400 text-sm flex flex-col items-end'>
                                                <span>{t('mint.购买价值')}</span>
                                                <span className='text-base mt-1 text-yellow-500'>
                                                   <NumberFormat
                                                    thousandsGroupStyle="thousand"
                                                    value={item.usdt}
                                                    prefix=""
                                                    decimalSeparator="."
                                                    fixedDecimalScale={true}
                                                    displayType="text"
                                                    type="text"
                                                    thousandSeparator={true}
                                                    allowNegative={false}
                                                    decimalScale={2} /></span>
                                                    
                                            </div>
                                        
                                        </div>
                                    </div>
                                    <div className=' w-full my-4 h-[1px] bg-[#0161F6]'></div>
                                    </>
                                    
                                )
                            }):(
                                
                                <div  className=' w-full  py-3 mt-5 flex flex-col items-center justify-center text-gray-600 text-lg'>
                                    <img  alt='rr' className='mb-4' src={require('../../assets/bcb/logo.png')} style={{"width":"80px"}}></img>
                                        {t('asset.暂未开放')}
                                </div>
                            )
                            }
                        
                        
                    </div>
                        
                        </>
                       
              
                
                
                {/*  */}

               

               

                

                <div className=' w-full h-32'></div>
            </div>
            
            
               
           <Foot/>
        </>
    );
}

const mapDispatchToProps = (dispatch) =>{
    return{

        setIsLogin(value){
            const action ={type:"setIsLogin",value:value}
            dispatch(action)
        },

        setPAddress(value){
            const action ={type:"setPAddress",value:value}
            dispatch(action)
        },
        setFlash(value){
            const action ={type:"setFlash",value:value}
            dispatch(action)
        },
        setIsTiao(value){
            const action ={type:"setIsTiao",value:value}
            dispatch(action)
        }
    }
}
export default connect(mapStateToProps,mapDispatchToProps)(Rank);
